import $ from 'jquery';
import React from 'react';
import OptionPopupView from "views/common/OptionPopupView";
import { createRoot } from "react-dom/client";
import { UpgradeToTeamContent } from '../../components/workspace/UpgradeToTeamContent';
import "./UpgradeToTeamPopupView.css";

const UpgradeToTeamPopupView = OptionPopupView.extend({

    "pageName": "Upgrade To Team Popup",

    initialize: function(options) {
        this._onStartUpgrade = options.onStartUpgrade;
        this._onMountStripeElement = options.onMountStripeElement;
        this._onCompletePayment = options.onCompletePayment;
        this._onFinalizeUpgrade = options.onFinalizeUpgrade;
        this._onCancelUpgrade = options.onCancelUpgrade;
        this._onInviteMembers = options.onInviteMembers;
        this._i18nModule = options.i18nModule;
        this._defaultName = options.defaultName || '';
        this._mode = options.mode || 'create';
        this._reactRoot = null;

        this.contentContainer$el = $('<div class="upgrade-to-team-popup-content"></div>');

        const contentView = {};
        contentView.$el = this.contentContainer$el;

        const viewOptions = {
            contentView: contentView,
            contentPosition: "text-not-white",
            addContentAfterEnhancement: true,
            displayTitle: false,
            id: "UpgradeToTeamPopup"
        };

        OptionPopupView.prototype.initialize.call(this, viewOptions);
    },

    onPopupClosed: function() {
        if (this._reactRoot) {
            this._reactRoot.unmount();
            this._reactRoot = null;
        }
    },

    onCloseTriggered: function() {
        this.close();
    },

    addReactWidget: function() {
        if (this._reactRoot) {
            this._reactRoot.unmount();
        }

        const root = createRoot(this.contentContainer$el.get(0));

        root.render(
            React.createElement(UpgradeToTeamContent, {
                onStartUpgrade: this._onStartUpgrade,
                onMountStripeElement: this._onMountStripeElement,
                onCompletePayment: this._onCompletePayment,
                onFinalizeUpgrade: this._onFinalizeUpgrade,
                onCancelUpgrade: this._onCancelUpgrade,
                onInvite: this._onInviteMembers,
                onClose: this.onCloseTriggered.bind(this),
                i18nModule: this._i18nModule,
                defaultName: this._defaultName,
                mode: this._mode,
                useEditorTheme: true
            })
        );

        this._reactRoot = root;
    },

    onAfterPageShow: function() {
        this.addReactWidget();
    },

    afterRender: function() {
        OptionPopupView.prototype.afterRender.call(this);
    }
});

export default UpgradeToTeamPopupView;
